

export default {
  methods: {
    t(key, params = []) {
      return this.$vuetify.locale.t(`$vuetify.${key}`, ...params);
    },
  },
};
